// ************************************ //
// Every page - framework functionality //
// ************************************ //

import $ from 'jquery';
import { NavLoad } from 'App/nav/load';

// These modules are always used
import { Social as SocialShare } from 'App/social/share';
import { Cookie } from 'App/cookie/cookie';
import { BackToTop } from 'App/back-to-top/back-to-top';
import 'phatfingaz';
NavLoad.init();
SocialShare.init();
Cookie.init();
BackToTop.init();

// Publish resize and scroll events for other modules to use
import { publish } from 'Util/pubsub';
import { throttle } from 'Util/throttle';

const $window = $(window);
$window.on('resize', throttle(() => publish('/window/resize'), 250));
$window.on('scroll', () => publish('/window/scroll'));

// These modules are loaded on-demand to reduce initial JS parse/eval cost
if (document.querySelector('.c-rte')) {
	import(/* webpackChunkName: "Rte" */ 'Controls/control.rte').then(({ Rte }) => {
		Rte.init();
	});
}

// Sticky subnav
if (document.querySelector('.js-sub-navigation')) {
	import(/* webpackChunkName: "StickySubnav" */ 'App/nav/nav.sticky-subnav').then(({ StickySubnav }) => {
		StickySubnav.init();
	});
}


// ********************************************************* //
// Controls - comment out any not being used by this project //
// ********************************************************* //

// Gallery Grid
const $galleryGrids = $('.js-gallery-grid');
if ($galleryGrids.length) {
	import(/* webpackChunkName: "GalleryGrid" */ 'Controls/control.gallery-grid').then(({ GalleryGrid }) => {
		GalleryGrid.init($galleryGrids);
	});
}

// Gallery Rotator
const $galleryRotators = $('.js-gallery-rotator');
if ($galleryRotators.length) {
	import(/* webpackChunkName: "GalleryRotator" */ 'Controls/control.gallery-rotator').then(({ GalleryRotator }) => {
		GalleryRotator.init($galleryRotators);
	});
}

// Google Maps
if (document.querySelector('.js-google-map')) {
	import(/* webpackChunkName: "GoogleMap" */ 'Controls/control.google-map').then(({ GoogleMap }) => {
		GoogleMap.init();
	});
}

// Locations List
if (document.querySelector('.js-locations-list__map')) {
	import(/* webpackChunkName: "LocationsList" */ 'Controls/control.locations-list').then(({ LocationsList }) => {
		LocationsList.init();
	});
}

// Logo Carousel
const $logoCarousels = $('.js-logo-carousel');
if ($logoCarousels.length) {
	import(/* webpackChunkName: "LogoCarousel" */ 'Controls/control.logo-carousel').then(({ LogoCarousel }) => {
		LogoCarousel.init($logoCarousels);
	});
}

// Pathway Carousel
const $pathwayCarousels = $('.js-pathway-carousel');
if ($pathwayCarousels.length) {
	import(/* webpackChunkName: "PathwayCarousel" */ 'Controls/control.pathway-carousel').then(({ PathwayCarousel }) => {
		PathwayCarousel.init($pathwayCarousels);
	});
}

// Testimonials Rotator
const $testimonialsRotators = $('.js-testimonials-rotator');
if ($testimonialsRotators.length) {
	import(/* webpackChunkName: "TestimonialsRotator" */ 'Controls/control.testimonials-rotator').then(({ TestimonialsRotator }) => {
		TestimonialsRotator.init($testimonialsRotators);
	});
}

// Latest Insights
const $latestInsights = $('.js-latest-insights');
if ($latestInsights.length) {
	import(/* webpackChunkName: "LatestInsights" */ 'Controls/control.latest-insights').then(({ LatestInsights }) => {
		LatestInsights.init($latestInsights);
	});
}

// ALL Rotators
const $Rotators = $('.js-rotator');
if ($Rotators.length) {
	import(/* webpackChunkName: "Rotator" */ 'App/rotator/rotator').then(({ Rotator }) => {
		Rotator.init($Rotators);
	});
}

// Expand and Collapse
if (document.querySelector('.js-expand-collapse')) {
	import(/* webpackChunkName: "ExpandCollapse" */ 'App/expand-collapse/expand-collapse').then(({ expandCollapse }) => {
		expandCollapse.init();
	});
}

// Select Link
if (document.querySelector('.js-select-link')) {
	import(/* webpackChunkName: "SelectLink" */ 'App/select-link/select-link').then(({ selectLink }) => {
		selectLink.init();
	});
}

// Video Group
if (document.querySelector('.js-video-group__item')) {
	import(/* webpackChunkName: "VideoGroup" */ 'App/video-group/video-group').then(({ VideoGroupLoad }) => {
		VideoGroupLoad.init();
	});
}

// Custom Form
if (document.querySelector('.js-custom-form')) {
	import(/* webpackChunkName: "FormCustom" */ 'App/form/form.custom').then(({ formCustom }) => {
		formCustom.init();
	});
}

// Offsite Form
if (document.querySelector('.offsiteeventleadcapture')) {
	import(/* webpackChunkName: "FormOffsite" */ 'App/form/form.offsite').then(({ formOffsite }) => {
		formOffsite.init();
	});
}

// Resources
if (document.querySelector('.js-resources__item')) {
	import(/* webpackChunkName: "Resources" */ 'App/resources/resources.resources').then(({ resource }) => {
		resource.init();
	});
}

// Form Validate
if (document.querySelector('.js-validate-form')) {
	import(/* webpackChunkName: "FormValidate" */ 'App/form/form.validate').then(({ formValidate }) => {
		formValidate.init();
	});
}

// Form Nav
if (document.querySelector('.js-nav-form')) {
	import(/* webpackChunkName: "FormNav" */ 'App/form/form.nav').then(({ formNav }) => {
		formNav.init();
	});
}

// Properties
if (document.querySelector('.js-properties')) {
	import(/* webpackChunkName: "Properties" */ 'App/properties/properties.properties').then(({ Properties }) => {
		Properties.init();
	});
}

// Filtered Properties
if (document.querySelector('.js-filtered-property-listing')) {
	import(/* webpackChunkName: "FilteredProperties" */ 'App/properties/properties.filtered-properties').then(({ FilteredProperties }) => {
		FilteredProperties.init();
	});
}

// Rotators self-initialises
//var $pageRotators = $('.js-rotator');
//import { Rotator } from 'App/rotator/rotator';
//if ($pageRotators.length) {
//	Rotator.init($pageRotators);
//}

// Form delegate
//import { FormDelegate } from 'App/form/form.delegate';
//if (document.querySelector('.js-form-delegate-primary')) {
//	FormDelegate.init();
//}

// Map Locations
if (document.getElementById('js-map-canvas')) {
	import(/* webpackChunkName: "MapLocations" */ 'App/map/map.locations').then(({ MapLocations }) => {
		MapLocations.init();
	});
}

document.querySelectorAll('a[target="_blank"]').forEach(anchor => {
	anchor.classList.add("External");
	anchor.insertAdjacentHTML("beforeend", '<div class="iconf-external"></div>');

	const title = anchor.getAttribute('title');

	if (title !== null) {
		anchor.setAttribute("title", `${title} - Opens in new window.`);
	} else {
		anchor.setAttribute('title', 'Opens in new window.');
	}
});

document.querySelectorAll('a[target="_nzpost"]').forEach(anchor => {
	anchor.classList.add("External");
	anchor.insertAdjacentHTML("beforeend", '<div class="iconf-external"></div>');
});

$('.js-hot').phatFingaz();


// Tealium Page Load Event Data

// Tealium Page Load Event Data
(function checkUtagAndSendEvent() {
    if (typeof utag !== 'undefined' && typeof utag_event_data !== 'undefined') {
        utag.link(utag_event_data);
    } else {
        setTimeout(checkUtagAndSendEvent, 200);
    }
})();

// Tealium link click event tracking - BUPAP-582
$('a').on('click', function () {
	var $link = $(this);

	if ($link && typeof utag !== 'undefined' && typeof utag_data !== 'undefined') {
		var clickText = $link.text().trim();
		var clickUrl = $link.attr('href');

		var eventData = {
			"click_text": clickText,
			"click_url": clickUrl,
			"page_name": utag_data.page_name,
			"category": utag_data.category,
			"tealium_event": "link_click"
		};

		//console.log(eventData);
		utag.link(eventData);
	}
});

//////////////////////////////////
// Any page, but not every page //
//////////////////////////////////

// Modal
if (document.querySelector('.js-modal')) {
	import(/* webpackChunkName: "Modal" */ 'App/modal/modal').then(({ modal }) => {
		modal.init({
			onShow: function ($modal) {
				var $rotators = $modal.find('.js-rotator');
				var thisFlick;
				$rotators.each(function (i, el) {
					thisFlick = $(el).data('flickity-instance');

					if (thisFlick) {
						thisFlick.resize();
					}
				});
			}
		});
	});
}

// Scroll Appear
if (document.querySelector('.js-scroll-appear')) {
	import(/* webpackChunkName: "ScrollAppear" */ 'App/scroll-appear/scroll-appear').then(({ scrollAppear }) => {
		scrollAppear.init();
	});
}

// Umbraco Forms
const $umbracoForms = $('.js-umbraco-form');
if ($umbracoForms.length) {
	import(/* webpackChunkName: "UmbracoForms" */ 'App/form/form.umbraco').then(({ UmbracoForms }) => {
		UmbracoForms.init();
	});
}

// Video Player
if (document.querySelector('.js-video-player')) {
	import(/* webpackChunkName: "VideoPlayer" */ 'App/video/video.player').then(({ VideoPlayer }) => {
		VideoPlayer.init();
	});
}

// Video Gallery
if (document.querySelector('.js-video-gallery')) {
	import(/* webpackChunkName: "VideoGallery" */ 'App/video/gallery').then(({ videoGallery }) => {
		videoGallery.init();
	});
}

// Event calendar add
if (document.querySelector('.js-calendar-link')) {
	import(/* webpackChunkName: "Calendar" */ 'App/event/calendar').then(({ Calendar }) => {
		Calendar.init();
	});
}


// Replace content with ajax
if (document.querySelector('.js-ajax-replace')) {
	import(/* webpackChunkName: "AjaxReplace" */ 'App/ajax/ajax.ajaxreplace').then(({ ajaxReplace }) => {
		ajaxReplace.init();
	});
}


document.addEventListener('DOMContentLoaded', function () {
	var submittedForm = document.getElementById('umbraco-forms-form-submitted');
	var submittedFormMessage = document.querySelector('.js-lead-capture-message');
	if (submittedForm) {
		submittedFormMessage.style.display = 'block';

		const y = submittedForm.getBoundingClientRect().top + window.pageYOffset - 200;
		window.scrollTo({ top: y, behavior: 'smooth' });
	}
});



// EnquireBtn click handle on page load
window.onload = function () {
	const propertyPage = document.querySelector(".js-property-page");

	if (propertyPage) {
		const hash = window.location.hash;
		if (hash) {
			const enquireBtn = document.querySelector(hash);

			if (enquireBtn) {
				enquireBtn.click();
			}
		}
	}
};
